import { apiClient } from "../../api-services/axios";
import { routes } from "./routes";

export const blockedNumber = (payload) => {
    return apiClient({
        method: routes.BLOCKED_NUMBER.METHOD,
        url: routes.BLOCKED_NUMBER.URL,
        data: payload,
    });
};

export const deleteNumber = (payload) => {
    return apiClient({
        method: routes.DELETE_NUMBER.METHOD,
        url: routes.DELETE_NUMBER.URL,
        data: payload,
    });
};
